import React from "react";
import { useUser } from "../context/UserContext";
import {
  LANDING_PAGE,
  LOGIN_PAGE,
  SESSION_TOKEN_STORAGE_NAME,
  VIEWER_LANDING_PAGE,
} from "../Constants";
import isMobileDevice from "../utils/isMobileDevice";

export default function Header() {
  const [user, setUser] = useUser();

  const handleSignout = () => {
    localStorage.removeItem(SESSION_TOKEN_STORAGE_NAME);
    setTimeout(() => {
      setUser(undefined);
    });
    window.location.href = LANDING_PAGE;
  };

  return (
    <div>
      <div className="left-align-text">
        <h1
          className="fa-pointer flexWrapper"
          onClick={() => {
            window.location.href = LANDING_PAGE;
          }}
        >
          H3AD
        </h1>
      </div>

      <div className="alignRight paddingright20">
        {user && (
          <div>
            <h5 className="font-weight-normal">User: {user.email_address}</h5>
            <h6 className="font-weight-normal">
              Subscription type: {user.subscription_type}
            </h6>
          </div>
        )}
        {isMobileDevice() && (
          <a href={VIEWER_LANDING_PAGE} className="buttonPrimary">
            Mobile Viewer
          </a>
        )}

        {user ? (
          <a onClick={handleSignout} className="buttonRed">
            Sign-out
          </a>
        ) : (
          <a href={LOGIN_PAGE} className="buttonPrimary">
            Sign-in
          </a>
        )}
      </div>
    </div>
  );
}
